<template>
	<span v-if="!dataList.length">-</span>
	<c-tooltip v-else-if="dataList.length > 1" position="top" color="white">
		<item-link :type-data="typeData" :data="dataList[0]"></item-link>
		<span> [共{{dataList.length}}条]</span>

		<template #tip>
			<p v-for="(item, i) in dataList" :key="i">
				<item-link :type-data="typeData" :data="item"></item-link>
			</p>
		</template>
	</c-tooltip>
	<item-link v-else :type-data="typeData" :data="dataList[0]"></item-link>
</template>

<script>
	const itemLink = {
		render(h) {
			return (
				this.typeData.auth && this.auth(this.typeData.auth) && this.typeData.comp ? [
					<c-link on-click={() => this.globalDialog(this.typeData.comp, {props: {id: this.data.id}})}>{this.data.code}
					{
						this.typeData.name ? [
							<span> [{this.typeData.name}]</span>
						] : []
					}
					</c-link>
				] : [
					<span style={`color: ${this.typeData.color}`}>{this.data.code}
						{
							this.typeData.name ? [
								<span> [{this.typeData.name}]</span>
							] : []
						}
					</span>
				]
			)
		},

		props: {
			typeData: Object,
			data: Object
		}
	}

	export default {
		name: 'orderLink',

		components: {
			itemLink
		},
		
		props: {
			type: [String, Number],
			id: [String, Number],
			code: [String, Number],
			data: String
		},
		
		computed: {
			typeData() {
				switch (this.type.toString()) {
				case 'order':
				case '1':
					return {
						name: '订单',
						auth: 'b_order_query',
						comp: 'orderDetail'
					}

				case 'plan':
				case '2':
					return {
						name: '计划',
						auth: 'm_plan',
						comp: 'planDetail'
					}

				case 'work':
				case '3':
					return {
						name: '工单',
						auth: 'm_work',
						comp: 'workDetail'
					}
					
				case 'stockin':
				case '4':
					return {
						name: '入库',
						auth: 'm_stockin',
						comp: 'stockinDetail'
					}	

				case 'task':
					return {
						auth: 'm_task',
						comp: 'taskDetail'
					}

				case 'output':
				case '14':
					return {
						name: '报工',
						auth: 'm_output',
						comp: 'outputDetail'
					}
					
				case '29':
					return {
						name: '委外单',
						auth: 'm_outsourcing_order',
						comp: 'outSourcingDetail'
					}
					
				case 'deliver':
				case '32':
					return {
						name: '发货',
						auth: 'm_order_deliver',
						comp: 'orderDeliverDetail'
					}

				case 'assemble':
				case '34':
					return {
						name: '装配',
						auth: 'm_assemble',
						comp: 'assembleDetail'
					}

				case 'purchase':
				case '39':
					return {
						name: '采购单',
						auth: 'm_purchase_order',
						comp: 'purchaseOrderDetail'
					}
					
				case 'qualityWork':
				case '45':
					return {
						name: '生产入库检',
						auth: 'm_quality_work',
						comp: 'qualityWorkDetail'
					}

				case '47':
					return  {
						name: '质检返工',
						color: 'var(--color-red)'
					}

				case 'outSourcing':
					return {
						auth: 'm_outsourcing_order',
						comp: 'outSourcingDetail'
					}

				default:
					return {};
				}
			},

			dataList() {
				if (!this.type) return [];

				if (this.data) {
					return this.data.split(',').map(item => {
						item = item.split('#-#');
						return {
							code: item[0],
							id: item[1]
						}
					});
				} else if (this.id) {
					return [{
						code: this.code || (this.typeData.auth ? '查看' : ''),
						id: this.id
					}];
				} else {
					return [];
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>